import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from "jquery";
import fetch from "isomorphic-fetch";
import db from "../dbconn";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import Modal from 'react-responsive-modal';
import aes256 from 'aes256';
import Swal from "sweetalert2";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
class payment_methods extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            nosessionredirect: false,
            windowHeight: 0,
            cardList: [],
            open: false,
            categoryList: [],
            swalButton: '',
            key: 'x!A%D*G-KaPdSgVkYp3s5v8y/B?E(H+M'
        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });

        this.loadCards();
    }

    componentDidMount() {

        document.title = "Payment Methods - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        var height = $(window).height();
        this.setState({windowHeight: height});
    }

    loadCards = () => {

        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {

                this.onOpenModal();
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                var url = API_ROOT + '/fetchsavedcards?customer_id=' + customer_id + '&customer_token=' + customer_token;

                fetch(url)
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {

                        this.onCloseModal();
                        if (data.status == 1) {


                            this.setState({cardList: data.card_data});
                        }
                    });


            }
        });
    };
    deleteCard = () => {
        if ($('.userCards:checked').val() !== undefined) {

            var dbconn = new db();

            dbconn.getAll().then(data => {

                if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                    this.setState({nosessionredirect: true});
                } else {

                    this.onOpenModal();
                    var customer_id = data[0].customer_id;
                    var customer_token = data[0].customer_token;
                    var url = API_ROOT + '/deletecard?customer_id=' + customer_id + '&customer_token=' + customer_token + "&safeid=" + $('.userCards:checked').val() + "&store_id=" + localStorage.getItem("store_id");

                    fetch(url)
                        .then(response => {
                            return response.json();
                        })
                        .then(data => {

                            this.onCloseModal();
                            if (data.status == 1) {


                                this.loadCards();
                                //this.setState({cardList: data.card_data});
                            }
                        });


                }
            });
        } else {

            this.state.swalButton.fire({
                title: 'Please select card first.',
                allowOutsideClick: false
            });


        }
    };

    render() {
        const {t} = this.props;
        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }

        const {open} = this.state;

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/myaccount'}></Link>
                        <h2 className="text-center">{t('payment_methods')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>
                <div className="mt-white full-height" style={{top: "45px", position: "relative"}}>
                    <div className="simple-box m-b-0 p-b-35 p-0 bkg-white full-height m-grey">
                        <form name="" className="" method="post" encType="multipart/form-data" action="#">
                            <div className="form-box w-75 div-center">
                                <div className="header-title">
                                    <h2 className="text-center font-size-20 m-0">{t('saved_payment_methods')}</h2>
                                </div>
                                <div className="header-content">
                                    <ul>
                                        {this.state.cardList.map((item, index) => {
                                            return (<li key={item.card_id}><input type="radio" className="userCards"
                                                                                  id={item.card_id}
                                                                                  name="userCards"
                                                                                  value={item.card_safe_id}/> <label
                                                htmlFor={item.card_id}> {item.card_type} -
                                                Exp. {item.card_month + "/" + item.card_year} - {item.card_number}</label>
                                            </li>);
                                        })}
                                    </ul>
                                </div>


                                <div className="form-box payment_method_box">

                                    <div className="form-group">
                                        <input type="button" id="btnRemoveCard" onClick={this.deleteCard}
                                               value={t('remove_card')}/></div>
                                    <div className="form-group">

                                        <Link to={'/card/add/0'} className="link_button" style={{width:"100%"}}>{t('add_card')}</Link>
                                    </div>

                                </div>
                               

                            </div>
                            <div className="clearfix"></div>

                        </form>
                    </div>
                </div>
                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>

                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(payment_methods));


// WEBPACK FOOTER //
// ./src/view_components/payment_methods.js